export default __webpack_public_path__ + "static/media/El_milagro_del_pozo._Alonso_Cano_(1638-1640).ae38180d.jpg";